export default "__VITE_ASSET__CH1F2NB5__"